import { h } from 'preact'
import styled from 'styled-components'
import checked from './checked.png'

const VoteOptionRadio = styled.input`
  width: 38px;
  height: 38px;
  overflow: hidden;
  position: absolute;
  vertical-align: middle;
  margin: 0px;
  background: transparent;
  opacity: 0;

  + div {
    vertical-align: middle;
    display: inline-block;
    width: 38px;
    height: 38px;
    border: 1px solid #acb3bb;
    position: relative;
    background: ${props => (props.checked ? `url(${checked})` : '#e2e2e2')};
  }
  :focus + div {
    outline-width: 2px;
    outline-style: solid;
    outline-color: Highlight;

    @media (-webkit-min-device-pixel-ratio: 0) {
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
    }
  }
`

const Container = styled.div`
  width: 38px;
  height: 38px;
  display: inline-block;
  margin-right: 10px;
`

export default props => (
  <Container>
    <VoteOptionRadio {...props} checked={props.checked} />
    <div />
  </Container>
)



// WEBPACK FOOTER //
// ./components/atoms/checkbox/index.js